import React from 'react';
import appIcon from '../../assets/app-icon.png'; 
import android from '../../assets/android-icon.png';
import { Link } from 'react-router-dom';
const LandingPage: React.FC = () => {
  return (
    <div style={{ fontFamily: 'system-ui, sans-serif', color: '#1A2B48', textAlign: 'center', backgroundColor: '#e9e7db', minHeight: '100vh' }}>  {/* Hero Section */}
      {/* Hero Section */}
   
      {/* --- NEW HEADER SECTION --- */}
      <header style={{ 
        position: 'sticky', 
        top: 0, 
        zIndex: 50, 
        backgroundColor: 'rgba(255, 255, 255, 0.8)', 
        backdropFilter: 'blur(8px)', 
        borderBottom: '1px solid rgba(0,0,0,0.05)',
        padding: '12px 24px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ 
              width: '40px', height: '40px', 
              flexShrink: 0,
              background: 'linear-gradient(135deg, #2563eb, #9333ea)', 
              borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow:'hidden' 
            }}>
              {/* This represents the Smartphone icon from your snippet */}
             <img 
          src={appIcon} 
          alt="App Icon" 
          style={{ 
            width: '100%', 
            height: '100%', 
            objectFit: 'cover' 
          }} 
        />
            </div>
            <h1 style={{ fontSize: '1.2rem', fontWeight: 'bold',color: 'black', margin: 0 }}>Remind Me Of My Scriptures</h1>
          </div>
          <nav style={{ display: 'flex', gap: '10px' }}>
            <Link to="/privacy" style={navButtonStyle}>Privacy</Link>
            <Link to="/terms" style={navButtonStyle}>Terms</Link>
          </nav>
        </div>
      </header>
      {/* --- END HEADER SECTION --- */}
      <section style={{ padding: '60px 20px' }}>
        { <img src={appIcon} alt="Icon" style={{ width: '150px', borderRadius: '32px', display: 'inline-block', boxShadow: '0 20px 40px rgba(0,0,0,0.1)', marginBottom: '20px', border: '4px solid white' }} />
         }
         <br/>
        <div style={{ backgroundColor: '#e9e7db',  border: '1px solid #bebcafff', color: 'black', display: 'inline-block', padding: '6px 16px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '15px' }}>
          Get it now
        </div>
        
        <h2 style={{ fontSize: '2.5rem', fontWeight: '444', color: 'black', margin: '10px 0' }}>Your Daily Scripture Companion</h2>
        <p style={{ fontSize: '1.1rem', color: 'black', maxWidth: '600px', margin: '0 auto 40px' }}>
          Stay connected to scripture with personalized reminders, engaging games, and powerful study tools.
        </p>
        {/* App Store Cards */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
         <div style={cardStyle}>
            <img src={android} alt="android icon"/>
            <span style={{ fontSize: '2rem' }}></span>
            <h3 style={{ margin: '10px 0 5px' }}>Android App</h3>
            <div style={badgeStyle}>Download on Play Store</div>
          </div>
         <div style={cardStyle}>
            <div  style={{ 
            width: '20%', 
            height: '20%', 

          }}>
         
                    </div>
                       <div style={iconContainerStyle}>
      <svg 
        width="30" 
        height="30" 
        viewBox="0 0 24 24" 
        fill="black"
      >
        <path d="M17.523 15.3414C17.5027 15.3317 14.8447 13.9045 14.8251 10.6466C14.8055 7.89502 16.9883 6.56525 17.0968 6.49601C15.7852 4.54738 13.7305 4.31689 13.0024 4.29785C11.2764 4.12451 9.60059 5.36426 8.72266 5.36426C7.82568 5.36426 6.44336 4.31689 4.99512 4.34619C3.13574 4.37549 1.41992 5.48779 0.463867 7.19873C-1.52148 10.7197 -0.0244141 16.0264 1.89648 18.9951C2.85254 20.4468 3.96484 22.0615 5.45557 22.0029C6.86816 21.9443 7.40527 21.0474 9.10645 21.0474C10.7881 21.0474 11.2861 22.0029 12.7666 21.9639C14.2959 21.9443 15.2617 20.5122 16.1782 19.0508C17.2803 17.3984 17.7197 15.7739 17.7392 15.6948C17.7002 15.6851 17.523 15.3414 17.523 15.3414ZM14.4385 2.71387C15.2227 1.75781 15.7598 0.458008 15.6123 -0.841797C14.5391 -0.792969 13.2285 -0.103027 12.4053 0.873047C11.6699 1.71875 11.0254 3.05859 11.1924 4.31689C12.3926 4.40527 13.6338 3.68994 14.4385 2.71387Z"/>
      </svg>
      </div>
             <span style={{ fontSize: '2rem' }}></span>
            <h3 style={{ margin: '10px 0 5px' }}>iOS App</h3>
            <div style={badgeStyle}>Download on App Store</div>
          </div>
        </div>
        <div style={{ 
    marginTop: '60px', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    gap: '8px',
    color: '#000000', // Matching the blue from your design
  
    cursor: 'default'
}}>
  <span style={{ fontSize: '0.9rem' }}>Learn More</span>
  
  {/* The Chevron (V-shape) using a simple SVG or character */}
  <div className="animate-bounce" style={{ fontSize: '1.2rem' }}>
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    >
      <path d="M7 13l5 5 5-5M7 6l5 5 5-5" />
    </svg>
  </div>
</div>
      </section>

      {/* Features Section */}
  <section style={{ padding: '40px 20px', backgroundColor: 'white', borderRadius: '40px 40px 0 0', boxShadow: '0 -10px 30px rgba(0,0,0,0.05)' }}>
        <h2 style={{ fontSize: '2rem', marginBottom: '50px' }}>Features</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '30px', maxWidth: '1100px', margin: '0 auto' }}>
          <FeatureItem icon="📂" color="#e9e7db" title="Categorize" description="Organize by topic or importance." />
          <FeatureItem icon="📅" color="#e9e7db" title="Scripture Reminders" description="Never miss reminding yourself of your scriptures" />
          <FeatureItem icon="🎮" color="#e9e7db" title="Scripture Games" description="Memorize through fun challenges." />
          <FeatureItem icon="📤" color="#e9e7db" title="Import/Export" description="Keep your data safe and portable." />
        </div>
      </section>
    <br/>
      <br/>
        <br/>
        <section style={{ padding: '40px 20px', backgroundColor: 'white', borderRadius: '40px 40px 0 0', boxShadow: '0 -10px 30px rgba(0,0,0,0.05)' }}>
        <h2 style={{ fontSize: '2rem', marginBottom: '50px' }}>Contact Us</h2>
        <div>
          jspiritcodedeveloper@gmail.com
        </div>
      </section>

      {/* Footer with Legal Links */}
    <footer style={{  backgroundColor: '#000000', backgroundImage: 'linear-gradient(to bottom, #000000, #000000)', color: 'white' }}>
        {/* <h3 style={{ marginBottom: '20px' }}>Stay Updated</h3>
        <button style={notifyButtonStyle}>Notify Me</button> */}
        
        <div style={{ marginTop: '50px', borderTop: '1px solid rgba(255,255,255,0.2)', paddingTop: '30px', display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: '20px' }}>
            <div style={{ textAlign: 'left' }}>
                
                <p style={{ fontWeight: 'bold' }}>Remind Me Of My Scriptures</p>
                <p style={{ fontSize: '0.8rem', opacity: 0.8 }}>© 2025 All rights reserved.</p>
            </div>
            <nav>
                <Link style={footerLinkStyle} to="/privacy">Privacy Policy</Link>
                <Link style={footerLinkStyle} to="/terms">Terms & Conditions</Link>
            </nav>
        </div>
      </footer>
    </div>
  );
};

// Reusable Feature Component
const FeatureItem = ({ title, description, icon, color }: any) => (
  
  <div style={{ padding: '20px', border: '1px solid #eee', borderRadius: '8px' }}>
    <div style={{ width: '64px', height: '64px', backgroundColor: color, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: '1.5rem', color: 'white', boxShadow: `0 10px 20px ${color}44` }}>
      {icon}
    </div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const cardStyle = {
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  padding: '30px',
  borderRadius: '10px',
  width: '150px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
  border: 'none'
};

const badgeStyle = {
    fontSize: '0.7rem',
    color: '#1E90FF',
    border: '1px solid #1E90FF',
    padding: '4px 10px',
    borderRadius: '10px',
    marginTop: '10px',
    display: 'inline-block'
};
// New Style for the Nav Buttons
const navButtonStyle = {
  padding: '8px 16px',
  borderRadius: '8px',
  textDecoration: 'none',
  color: '#4B5563',
  fontSize: '0.9rem',
  fontWeight: '500',
  transition: 'background 0.2s',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer'
};
// const notifyButtonStyle = {
//     backgroundColor: 'white',
//     color: '#5E5CE6',
//     border: 'none',
//     padding: '12px 30px',
//     borderRadius: '30px',
//     fontWeight: 'bold',
//     cursor: 'pointer',
//     boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
//};
const iconContainerStyle = {
  display: 'flex',
  justifyContent: 'center', // Centers horizontally
  alignItems: 'center',     // Centers vertically
  height: '20px',           // Fixed height to keep cards uniform
  width: '100%',
  marginBottom: '10px'
};
const footerLinkStyle = { margin: '0 15px', color: 'white', textDecoration: 'none', fontSize: '0.9rem', opacity: 0.8 };
export default LandingPage;